<mat-form-field
    [color]="color"
    [subscriptSizing]="subscriptSizing"
    class="text-input-form-field w-full"
    [class.no-label]="!label || label === ''"
    title="{{ label?.length ? label + ': ' : ''}}{{ formControl.getRawValue() }}"
>   
    <mat-label *ngIf="label?.length" [class]="labelClass">
        {{ label }}
    </mat-label>


    <ng-content select="[matIconPrefix]"></ng-content>
    <ng-content select="[matPrefix]"></ng-content>

    <input
        [disabled]="isDisabled"
        [errorStateMatcher]="textFieldErrorStateMatcher"
        [formControl]="formControl"
        [placeholder]="placeholder"
        [readonly]="isDisabled"
        [step]="step"
        [type]="type"
        [attr.autocomplete]="autocomplete"
        matInput
    >

    <ng-content></ng-content>

    <ng-content select="[matIconSuffix]"></ng-content>
    <ng-content select="[matSuffix]"></ng-content>

    <mat-error>{{ errorMessage }}</mat-error>
</mat-form-field>

